import { configureStore } from '@reduxjs/toolkit'
import { apiAuthSlice } from './features/authentication/apiAuthentication'
import { apiCloudSystemSlice } from './features/cloudsystem/apiCloudSystem'
import { apiDashboardSlice, uncommissionedSummariesSlice } from './features/dashboard/apiDashboard'
import { apiErrorSlice, rtkQueryErrorLogger } from './features/error/apiError'

export default configureStore({
  reducer: {
    [apiAuthSlice.name]: apiAuthSlice.reducer,
    [apiDashboardSlice.reducerPath]: apiDashboardSlice.reducer,
    [apiCloudSystemSlice.reducerPath]: apiCloudSystemSlice.reducer,
    [apiErrorSlice.name]: apiErrorSlice.reducer,
    [uncommissionedSummariesSlice.name]: uncommissionedSummariesSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(apiDashboardSlice.middleware)
      .concat(apiCloudSystemSlice.middleware)
      .concat(rtkQueryErrorLogger)
})